










































































































































import Vue from "vue";
import { mapGetters, mapMutations, mapActions } from "vuex";
import { ValidationProvider, extend, ValidationObserver } from "vee-validate";
import { required, numeric } from "vee-validate/dist/rules";

extend("required", {
  ...required,
  message: "Vui lòng điền đầy đủ thông tin!"
});
extend("numeric", {
  ...numeric,
  message: "Vui lòng chỉ nhập số!"
});

export default Vue.extend({
  name: "FarmerForm",
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      id: null,
      fullname: null,
      phone: null,
      idcard: null,
      idcardAddress: null,
      address: null,
      point: 0,
      code: null,
      lat: null,
      lng: null,
      cardNumber: null,
      idcardDate: null
    };
  },
  computed: {
    ...mapGetters({
      farmerModal: "farmer/farmerModal",
      updatePointLoading: "farmer/updatePointLoading"
      // branchs: "branch/items"
    })
  },
  methods: {
    async handleUpdatePoint() {
      const res = await this.updatePoint(this.id);
      this.point = res;
    },
    showValue(e) {
      if (!e.target.value) {
        this.address = null;
      }
    },
    setPlace(place) {
      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();
      this.address = place.formatted_address;
    },
    removeImg(e) {
      e.stopPropagation();
      this.image = null;
    },
    ...mapActions({
      createNewFarmer: "farmer/createNewFarmer",
      updateFarmer: "farmer/updateFarmer",
      updatePoint: "farmer/updatePoint"
    }),
    ...mapMutations({
      closeModal: "farmer/closeModal"
    }),

    addNewFarmer() {
      const newFarmer = {
        fullname: this.fullname,
        idcard: this.idcard,
        idcardAddress: this.idcardAddress,
        address: this.address,
        point: this.point || 0,
        phone: this.phone,
        code: this.code,
        cardNumber: this.cardNumber,
        idcardDate: this.idcardDate
      };
      this.createNewFarmer(newFarmer);
    },
    editFarmer() {
      const newFarmer = {
        fullname: this.fullname,
        idcard: this.idcard,
        idcardAddress: this.idcardAddress,
        address: this.address,
        point: this.point || 0,
        phone: this.phone,
        code: this.code,
        cardNumber: this.cardNumber,
        idcardDate: this.idcardDate
      };
      this.updateFarmer({ id: this.id, farmer: newFarmer });
    }
  },
  updated() {
    this.id = this.farmerModal._id;
    this.fullname = this.farmerModal.fullname;
    this.idcard = this.farmerModal.idcard;
    this.code = this.farmerModal.code;
    this.address = this.farmerModal.address;
    this.point = this.farmerModal.point || 0;
    this.phone = this.farmerModal.phone;
    this.cardNumber = this.farmerModal.cardNumber;
    this.idcardAddress = this.farmerModal.idcardAddress;
    this.idcardDate = this.farmerModal.idcardDate;
  }
});
